import { REACT_APP_API_KEY } from '../../utils';

interface FetchOptions {
	method: string;
	endpoint: string;
	data?: any;
}

interface FetchOptionsForm {
	method: string;
	endpoint: string;
	body?: any;
}

const handleUnauthorized = () => {
	localStorage.removeItem('accessToken');
	localStorage.removeItem('refreshToken');
	// Optionally, you can redirect the user to the login page here
	// window.location.href = '/login';
};

const fetchHandler = async ({ method, endpoint, data }: FetchOptions) => {
	const API_BASE_URLS = `${REACT_APP_API_KEY}${endpoint}`;
	const headers: HeadersInit = {
		'Content-Type': 'application/json',
	};
	const accessToken = localStorage.getItem('accessToken');
	if (accessToken) {
		headers.Authorization = `Bearer ${accessToken}`;
	}

	const options: RequestInit = {
		method,
		headers,
		cache: 'no-cache',
		credentials: 'same-origin',
	};

	if (method !== 'GET' && data) {
		options.body = JSON.stringify(data);
	}

	try {
		const response = await fetch(API_BASE_URLS, options);

		if (response.ok) {
			const result = await response.json();
			return result;
		} else {
			if (response.status === 401) {
				handleUnauthorized();
			}
			const result = await response.json();
			return { isError: true, data: result };
		}
	} catch (error) {
		console.error('Fetch error:', error);
		return {
			isError: true,
			data: "We can't process your request at this time. Please try later.",
		};
	}
};

export default fetchHandler;

export const fetchHandler2 = async ({ method, endpoint, data }: FetchOptions) => {
	const API_BASE_URLS = `${REACT_APP_API_KEY}${endpoint}`;
	const headers: HeadersInit = {
		'Content-Type': 'application/json',
	};
	const accessToken = localStorage.getItem('accessToken');
	if (accessToken) {
		headers.Authorization = `Bearer ${accessToken}`;
	}

	const options: RequestInit = {
		method,
		headers,
		cache: 'no-cache',
		credentials: 'same-origin',
	};

	if (method !== 'GET' && data) {
		options.body = JSON.stringify(data);
	}

	try {
		const response = await fetch(API_BASE_URLS, options);

		if (response.ok) {
			const result = await response.json();
			return result;
		} else {
			if (response.status === 401) {
				handleUnauthorized();
			}
			const result = await response.json();
			return { isError: true, data: result };
		}
	} catch (error) {
		console.error('Fetch error:', error);
		return {
			isError: true,
			data: "We can't process your request at this time. Please try later.",
		};
	}
};

export const fetchHandlerForm = async ({ method, endpoint, body }: FetchOptionsForm) => {
	const API_BASE_URLS = `${REACT_APP_API_KEY}${endpoint}`;
	const headers: HeadersInit = {};

	const accessToken = localStorage.getItem('accessToken');
	if (accessToken) {
		headers.Authorization = `Bearer ${accessToken}`;
	}

	const options: RequestInit = {
		method,
		headers,
		cache: 'no-cache',
		credentials: 'same-origin',
	};

	if (method !== 'GET' && body) {
		options.body = body;
	}

	try {
		const response = await fetch(API_BASE_URLS, options);

		if (response.ok) {
			const result = await response.json();
			return result;
		} else {
			if (response.status === 401) {
				handleUnauthorized();
			}
			const result = await response.json();
			return { isError: true, data: result };
		}
	} catch (error) {
		console.error('Fetch error:', error);
		return {
			isError: true,
			data: "We can't process your request at this time. Please try later.",
		};
	}
};
